import { controls, currencyToNumber, grouped } from "../../controls";

const rpsl12 = {
    label: "Suraksha Bima SLBC",
    starting: true,
    url: "rpsl12",
    pageLabel: "Suraksha Bima SLBC",
    pageType: "history",
    // filteraction: true,
    filter: [
        ...controls.displayText({ tab: "filter", label: "Reporting Season", star: true }),
        ...controls.autoComplete({ tab: "filter", name: "manual_report_master_code", width: "col-sm-2", controlType: "ManualReportMaster" }),
        ...controls.displayText({ tab: "filter", label: "" }),
    ],
    form: [],
    history: {
        perPage: 50,
        reportHeader: "Suraksha Bima SLBC",
        filterable: true,
        sortable: true,
        defaultsTo: 0,
        pdfProps: {
            pageSize: "A4", pageOrientation: "portrait"
        },
        textReportProps: {
            'slbc': {
                filename: `Suraksha Bima.txt`,
                format: {},
                separator: "|"
            },
        },

        displayColumns: [

            {
                Header: "State Code",
                accessor: "slbc_state_no",

            },

            {
                Header: "District Code",
                accessor: "slbc_district_no",

            },
            {
                Header: "Block Code",
                accessor: "slbc_block_code",
            },
            {
                Header: "Total No. of Enrolment under PMJJBY",
                accessor: "total_enrolment_under_pmjjby"

            },
            {
                Header: "Total No of eligible cases under PMJJBY",
                accessor: "total_eligible_cases_under_pmjjby",
                
            },
            {
                Header: "Total No of renewals under PMJJBY",
                accessor: "total_renewals_under_pmjjby"
            },
            {
                Header: "Total No. of Enrolment under PMSBY",
                accessor: "total_enrolment_under_pmsby",
                
            },


            {
                Header: "Total No of eligible cases under PMSBY",
                accessor: "total_eligible_cases_under_pmsby"

            },
            {
                Header: "Total No. of renewals under PMSBY",
                accessor: "total_renewals_under_pmsby",

            },

            {
                Header: "Total No. of Enrolment under APY",
                accessor: "total_enrolment_under_apy",
                
            },
           
        ]
    }
};

export default rpsl12;